<template>
  <div class="main-container">
    <div class="main-left">
      <div class="catalog-content">
        <div
          class="catalog-title-box"
          :class="{ 'catalog-title-box-active': index == activeIndex }"
          v-for="(item, index) in titleList"
          :key="index"
        >
          <div class="title" @click="toScroll(index)">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="main-right" ref="mainRight">
      <div>
        <div class="breadcrumb">
          <span>当前位置：</span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>帮助</el-breadcrumb-item>
            <el-breadcrumb-item>更新日志</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="logs-box">
          <div class="logs-title">更新日志</div>
          <div class="logs-time">发布时间：2022-12</div>
          <div
            class="logs-content"
            :id="'log' + index"
            v-for="(item, index) in logsList"
            :key="index"
          >
            <div class="logs-version">
              <span>{{ item.name }}</span
              ><span>{{ item.time }}</span>
            </div>
            <div v-for="(list, i) in item.children" :key="i">
              <div class="logs-moduleName">{{ list.moduleName }}</div>
              <p class="logs-txt" v-for="(l, n) in list.thirdChildren" :key="n">
                {{ l.content }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toTop" @click="toTop">
      <img src="../../assets/icon/toTop.png" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titleList: ["北斗网格时空引擎在线平台V1.0"],
      activeIndex: 0,
      logsList: [
        {
          name: "北斗网格时空引擎在线平台V1.0",
          time: "2022-12",
          children: [
            {
              moduleName: "一、产品功能模块",
              thirdChildren: [
                {
                  content: "1.支持二维、三维全球网格绘制",
                },
                {
                  content: "2.支持二维点、线、面标绘，并绘制相应网格",
                },
                {
                  content: "3.支持三维点、线、多边立方体标绘，并绘制相应网格",
                },
                {
                  content: "4.支持WKT网格标绘，并绘制相应网格",
                },
                {
                  content:
                    "5.支持二维和三维依据经纬度、高度等信息，输出GGER编码并绘制相应网格",
                },
                {
                  content:
                    "6.支持二维和三维依据GGER编码，输出坐标范围并绘制相应网格",
                },
                {
                  content: "7.支持二维和三维GGER编码和BGC编码转换",
                },
                {
                  content:
                    "8.支持二维网格的子网格和父网格查询，输出其GGER编码及对应网格码",
                },
                {
                  content:
                    "9.支持二维网格的四邻域和八邻域网格查询，输出其GGER编码及对应网格码",
                },
                {
                  content:
                    "10.支持三维网格的子网格和父网格查询，输出其GGER编码及对应网格码",
                },
                {
                  content:
                    "11.支持三维网格的六邻域、十八邻域和二十六邻域网格查询，输出其GGER编码及对应网格码",
                },
                {
                  content:
                    "12.支持任意两个二维、三维网格集间相交、包含、被包含以及相等关系的判断",
                },
                {
                  content:
                    "13.支持任意二维、三维网格集间交集和并集的查询，输出交集或并集的GGER码集合，并绘制相应网格集",
                },
                {
                  content:
                    "14.支持全局三种基本网格样式切换，及用户自定义样式设置",
                },
                {
                  content:
                    "15.支持全局底图切换，地图缩放，网格码拾取等基本操作",
                },
                {
                  content:
                    "16.支持控制视角绕点旋转，移动单点视角，俯视视角调整，视角缩放等操作",
                },
              ],
            },
            {
              moduleName: "二、开发者中心模块",
              thirdChildren: [
                {
                  content:
                    "1.支持全球网格、网格标绘、WKT标绘、网格码解码、二维和三维邻近查询、空间叠置分析等服务API调用",
                },
                {
                  content: "2.支持查询API概述、输入及输出参数",
                },
              ],
            },
            {
              moduleName: "三、帮助模块",
              thirdChildren: [
                {
                  content: "1.支持在线查询平台用户手册",
                },
                {
                  content: "2.支持平台更新日志、版本信息查询",
                },
              ],
            },
            {
              moduleName: "四、设置模块",
              thirdChildren: [
                {
                  content: "1.支持用户新增自定义底图，设置底图显示顺序",
                },
                {
                  content: "2.支持自定义底图位置移动、删除",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    toScroll(index) {
      this.activeIndex = index;
      let tabsId = document.querySelector(`#log${index}`);
      let el = document.querySelector(".main-right");
      // 判断进行平滑滚动
      if (tabsId) {
        el.scrollTo({
          top: tabsId.offsetTop - el.offsetTop,
          behavior: "smooth",
        });
      }
    },
    toTop() {
      let el = document.querySelector(".main-right");
      el.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  position: relative;
  .toTop {
    position: absolute;
    right: -40px;
    bottom: 10px;
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.2);
    text-align: center;
    cursor: pointer;
    img {
      margin-top: 8px;
    }
  }
  .main-left {
    height: 200px;
    width: 320px;
    .catalog-content {
      margin: 10px 0;
      flex-direction: column;
      display: flex;
      .catalog-title-box {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        color: #333;
        font-size: 16px;
        padding-left: 30px;
        position: relative;
        height: 40px;
        line-height: 40px;
        .title {
          padding-left: 12px;
          padding-right: 10px;
          display: flex;
          cursor: pointer;
          align-items: center;
          width: 100%;
        }
      }
      .catalog-title-box:before {
        content: " ";
        position: absolute;
        background-color: #fff;
        display: inline-block;
        border: 1px solid #c7c7c7;
        border-radius: 50%;
        top: 15px;
        margin-right: 12px;
        left: 20px;
        width: 9px;
        height: 9px;
      }
      .catalog-title-box-active:before {
        background-color: #00e3e4;
      }
      .catalog-title-box-active {
        color: #00e3e4;
      }
      .catalog-title-box:after {
        content: " ";
        display: block;
        position: absolute;
        left: 25px;
        top: 14px;
        transform: translateX(-50%);
        width: 2px;
        height: 40px;
        margin-top: 12px;
        background: #d8d8d8;
      }
      .catalog-title-box:last-child:after {
        display: none;
      }
    }
  }
  .main-right {
    width: calc(100vw - 320px);
    height: calc(100vh - 110px);
    overflow-y: auto;
    overflow-x: hidden;
    .logs-box {
      overflow: hidden;
      .logs-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin: 15px 0;
      }
      .logs-time {
        font-size: 14px;
        color: #666;
      }
      .logs-content {
        margin: 15px 0 20px;
        .logs-version {
          font-weight: 600;
          font-size: 18px;
          color: #333;
          margin-bottom: 10px;
          span {
            margin-right: 100px;
          }
        }
        .logs-moduleName {
          font-size: 16px;
          margin: 15px 0;
        }
        .logs-txt {
          font-size: 14px;
          color: #666;
          line-height: 25px;
        }
      }
    }
  }
}
</style>